import React from 'react'
import PropTypes from 'prop-types'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'
import { Collapse } from 'react-bootstrap'
import { client } from '../../utils'
import { customizeContent as endpoints } from '../../api_urls'
import SaveBar from './SaveBar'
import SuccessMessage from './SuccessMessage'

const SortableChapter = SortableElement(props => (
  <div
    className="container-md p-3 m-3 w-90 rounded bg-white pointer shadow border-dotted"
    key={props.index}
  >
    <div className="d-flex flex-row justify-content-start ml-3">
      <h3 className="black d-flex align-items-middle">
        <span className="icon icon_menu9 darkgrey mr-3 fs-xl" />
        <span>{props.title}</span>
      </h3>
    </div>
  </div>
))

const SortableList = SortableContainer(({ chapters }) => {
  return (
    <div className="ContentManager text-left">
      {chapters.map((chapter, index) => (
        <SortableChapter title={chapter[0]} key={chapter[1]} index={index} />
      ))}
    </div>
  )
})

class ContentManager extends React.Component {
  static propTypes = {
    chapters: PropTypes.array.isRequired,
    coursenum: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      chapters: props.chapters,
      saving: false,
      success: false,
      comparison: props.chapters,
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(prevState => {
      return { chapters: arrayMove(prevState.chapters, oldIndex, newIndex) }
    })
  }

  handleSave = async () => {
    this.setState({ saving: true })
    let chapIds = []
    this.state.chapters.map(chapter => chapIds.push(chapter[1]))
    let url = endpoints.save()
    try {
      var response = await client.post(url, chapIds)
      if (response['status'] === 200) {
        this.SuccessShow()
        this.setState(prevState => {
          return { comparison: prevState.chapters }
        })
      } else {
        console.error(response['error'] + response['status'])
      }
    } catch (err) {
      console.error(`Error posting ${url}`, err)
    }
    this.setState({ saving: false })
  }

  SuccessShow = () => {
    this.setState({ success: true })
    setTimeout(() => {
      this.setState({ success: false })
    }, 3000)
  }

  SuccessDismiss = () => {
    this.setState({ success: false })
  }

  render() {
    let collapsed = this.state.chapters !== this.state.comparison
    return (
      <div>
        <SuccessMessage
          success={this.state.success}
          dismiss={this.SuccessDismiss}
        />
        <SortableList
          chapters={this.state.chapters}
          onSortEnd={this.onSortEnd}
          helperClass="DragHelper"
        />
        <Collapse in={collapsed}>
          <div
            className={`${
              collapsed
                ? 'fixed-bottom text-white bg-dark-transparent p-3 d-flex flex-row justify-content-end'
                : ''
            }`}
          >
            <span className="p-3">
              Saving changes will immediately reorder the content for all users.
            </span>
            <SaveBar saving={this.state.saving} handleSave={this.handleSave} />
          </div>
        </Collapse>
      </div>
    )
  }
}

export default ContentManager
